import React from 'react';
import {
  MODAL_TYPES,
  ORDER_STATUS_TYPES,
  ROLE_TYPES,
  VIDEO_TYPES,
} from '@/constants/constants.js';
import { updateTaskStatus } from '@/features/orders/ordering/services/orderWorkflowService.js';
import { getReviewActionLabel } from '@/features/automation/videoEditing/utils/productionEntryUtils.js';

export const adminTaskStatusConfig = {
  [ORDER_STATUS_TYPES.审核中]: {
    display: null,
    actions: [
      {
        label: '审核通过',
        action: 'approve',
        className: 'btn btn-outline-dark',
      },
      {
        label: '审核不通过',
        action: 'reject',
        className: 'btn btn-outline-dark',
      },
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.资料修改中]: {
    display: '资料修改中，无审批操作',
    actions: [],
  },
  [ORDER_STATUS_TYPES.工作流待开始]: {
    display: null,
    actions: (task) => {
      const baseActions = [];
      if (
        task.videoType === VIDEO_TYPES.数字音容版 ||
        task.videoType === VIDEO_TYPES.数字音容Plus
      ) {
        baseActions.push(
          {
            label: '完结',
            action: 'closeOrder',
            className: 'btn btn-success',
          },
          {
            label: '详情页',
            action: 'NavigateToOnlyViewPage',
            className: 'btn btn-success',
          }
        );
      } else {
        baseActions.push(
          {
            label: '工作流待开始',
            action: 'NavigateToDetailPage',
            className: 'btn btn-outline-info',
          },
          {
            label: '详情页',
            action: 'NavigateToOnlyViewPage',
            className: 'btn btn-success',
          }
        );
      }

      return baseActions;
    },
  },
  [ORDER_STATUS_TYPES.工作流进行中]: {
    display: null,
    actions: [
      {
        label: '重启工作流',
        action: 'NavigateToDetailPage',
        className: 'btn btn-outline-warning',
      },
      {
        label: '查看工作流结果',
        action: 'view',
        className: 'btn btn-dark',
      },
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.工作流已完成]: {
    display: null,
    actions: [
      {
        label: '重启工作流',
        action: 'NavigateToDetailPage',
        className: 'btn btn-outline-success',
      },
      {
        label: '查看工作流结果',
        action: 'view',
        className: 'btn btn-dark',
      },
      {
        label: '完结',
        action: 'closeOrder',
        className: 'btn btn-success',
      },
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.工作流失败]: {
    display: null,
    actions: [
      {
        label: '重启工作流',
        action: 'NavigateToDetailPage',
        className: 'btn btn-outline-danger',
      },
      {
        label: '查看工作流结果',
        action: 'view',
        className: 'btn btn-dark',
      },
      {
        label: '完结',
        action: 'closeOrder',
        className: 'btn btn-success',
      },
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.视频制作中]: {
    display: '制作中，无需审批操作',
    actions: [],
  },
  [ORDER_STATUS_TYPES.已完成]: {
    display: null,
    actions: (task) => {
      const Actions = [];
      if (task.hasAutomation === true) {
        Actions.push({
          label: '查看工作流结果',
          action: 'view',
          className: 'btn btn-dark',
        });
      }
      Actions.push({
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      });
      return Actions;
    },
  },
  [ORDER_STATUS_TYPES.未提交]: {
    display: '未提交，无需操作',
    actions: [],
  },
  default: {
    display: '等待用户确认视频文案，无需审批操作',
    actions: [],
  },
};

// 定义非管理员的任务状态配置
export const companyTaskStatusConfig = {
  [ORDER_STATUS_TYPES.审核中]: {
    display: null,
    actions: [
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.资料修改中]: {
    display: null,
    actions: [
      {
        label: '前往修改资料',
        action: 'NavigateToModifyData',
        className: 'btn btn-outline-primary',
      },
    ],
  },
  [ORDER_STATUS_TYPES.视频制作中]: {
    display: null,
    actions: [
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.已完成]: {
    display: null,
    actions: [
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
  [ORDER_STATUS_TYPES.未提交]: {
    display: null,
    actions: [
      {
        label: '补充资料',
        action: 'NavigateToModifyData',
        className: 'btn btn-outline-primary',
      },
    ],
  },
  default: {
    display: null,
    actions: [
      {
        label: '确认文案',
        action: 'NavigateToConfirmPage',
        className: 'btn btn-outline-primary',
      },
    ],
  },
};

export const staffTaskStatusConfig = {
  default: {
    display: null,
    actions: [
      {
        label: '详情页',
        action: 'NavigateToOnlyViewPage',
        className: 'btn btn-success',
      },
    ],
  },
};

export const handleApiRequest = async (clientId, status) => {
  try {
    const response = await updateTaskStatus(clientId, status);
    return response.data;
  } catch (error) {
    console.error('更新状态失败:', error);
    throw error;
  }
};

export const createActionHandlers = (
  userid,
  role,
  workingOrder,
  setModalVisible,
  setModalType,
  setConfirmText,
  handleStartBtnClick,
  handleTaskResultClick,
  fetchData,
  navigate,
  setSelectedOrder
) => ({
  approve: async (task) => {
    try {
      setSelectedOrder(task);
      setModalType(MODAL_TYPES.人员分配);
      setConfirmText('确定分配');
      setModalVisible(true);
      await handleApiRequest(task.client_id, ORDER_STATUS_TYPES.工作流待开始);
      fetchData(userid, role);
    } catch (error) {
      console.error('审核通过操作失败', error);
    }
  },

  reject: async (task) => {
    try {
      setSelectedOrder(task);
      setModalType(MODAL_TYPES.确认审核不通过);
      setConfirmText('确认审核不通过');
      setModalVisible(true);
    } catch (error) {
      console.error('审核不通过操作失败', error);
    }
  },

  view: async (task) => {
    try {
      handleTaskResultClick(task.client_id);
    } catch (error) {
      console.error('查看操作失败', error);
    }
  },

  NavigateToDetailPage: async (task) => {
    try {
      if (workingOrder) {
        setModalType(MODAL_TYPES.存在正在进行的工作流);
        setConfirmText('确认');
        setModalVisible(true);
        setSelectedOrder(task);
      } else {
        handleStartBtnClick(task.client_id);
      }
    } catch (error) {
      console.error('查看操作失败', error);
    }
  },

  closeOrder: async (task) => {
    try {
      setModalType(MODAL_TYPES.确认完结订单);
      setConfirmText('确认完结');
      setSelectedOrder(task);
      setModalVisible(true);
    } catch (error) {
      console.error('关闭订单操作失败', error);
    }
  },

  NavigateToModifyData: async (task) => {
    try {
      navigate(`/${task.status}/${task.client_id}`);
    } catch (error) {
      console.error('前往修改资料操作失败', error);
    }
  },

  NavigateToConfirmPage: async (task) => {
    try {
      navigate(`/1/${task.client_id}`);
    } catch (error) {
      console.error('前往确认页面操作失败', error);
    }
  },

  NavigateToOnlyViewPage: async (task) => {
    try {
      navigate(`/review/${task.client_id}`);
    } catch (error) {
      console.error('前往查看页面操作失败', error);
    }
  },
});

export const AdminTaskAction = ({
  task,
  actionHandlers,
  role,
  handleTaskClick,
  renderTaskName = false,
  containerClassName = 'operation-container',
}) => {
  const handleAction = (action) => {
    const handler = actionHandlers[action];
    if (typeof handler === 'function') {
      handler(task);
    }
  };

  const currentConfig =
    role === ROLE_TYPES.管理员
      ? adminTaskStatusConfig
      : role === ROLE_TYPES.客服
      ? companyTaskStatusConfig
      : role === ROLE_TYPES.制作人员
      ? staffTaskStatusConfig
      : { default: { display: null, actions: [] } };

  const { display, actions } =
    currentConfig[task.status] || currentConfig.default;

  const actionList = typeof actions === 'function' ? actions(task) : actions;
  const displayList = typeof display === 'function' ? display(task) : display;

  const handleTaskNameClick = () => {
    if (
      (role === ROLE_TYPES.客服 || role === ROLE_TYPES.制作人员) &&
      actionList.length > 0
    ) {
      const firstAction = actionList[0]?.action;
      if (firstAction) {
        handleAction(firstAction);
      }
    } else {
      handleTaskClick(task.status, task.client_id);
    }
  };

  return (
    <div className={containerClassName}>
      {renderTaskName ? (
        <button
          onClick={handleTaskNameClick}
          className="btn btn-link"
          disabled={
            role === ROLE_TYPES.制作人员 &&
            task.status === ORDER_STATUS_TYPES.已完成
          }
        >
          {task.clientName}
        </button>
      ) : (
        <>
          {displayList && <div>{displayList}</div>}

          {actionList.map(({ label, action, className }, index) => (
            <button
              key={index}
              className={className}
              onClick={() => handleAction(action)}
              disabled={
                action === 'NavigateToOnlyViewPage' &&
                role === ROLE_TYPES.制作人员 &&
                task.status === ORDER_STATUS_TYPES.已完成
              }
            >
              {getReviewActionLabel({ role, label, action })}
            </button>
          ))}
        </>
      )}
    </div>
  );
};
